<template>
  <tr class="metric-user" @click="onEdit">
    <td>
      <div class="email">{{user.email}}</div>
      <div class="description">Individual, Paid through 4/8/2018</div>
    </td>
    <td class="text-center number hidden-phone">{{ new Date(user['registration-date']).toLocaleDateString() }}</td>
    <td class="text-center"><div class="status" :class="status"></div></td>
    <td class="text-center number hidden-phone">{{user.palettes}}</td>
    <td class="text-center number hidden-phone">{{user.ui}}</td>
    <!-- <td class="text-center number hidden-phone">6/20</td> -->
  </tr>
</template>

<script>
export default {
  name: 'metric-user',
  props: {
    onEdit: Function,
    user: Object,
  },
  data() {
    let status;
    if (this.user['access-type'].startsWith('trial')) {
      status = 'yellow';
    } else if (this.user['access-type'].startsWith('paid')) {
      status = 'green';
    } else if (this.user['access-type'].startsWith('override')) {
      status = 'gray';
    } else {
      status = 'blue';
    }

    return {
      status,
    };
  },
  watch: {
    user(to) {
      let status;
      if (to['access-type'].startsWith('trial')) {
        status = 'yellow';
      } else if (to['access-type'].startsWith('paid')) {
        status = 'green';
      } else if (to['access-type'].startsWith('override')) {
        status = 'gray';
      } else {
        status = 'blue';
      }

      this.status = status;
    },
  },
};
</script>

<style lang="scss" scoped>
  .metric-user {
    cursor: pointer;
  }

  td {
    padding: 15px 0;
    vertical-align: middle;
  }

  .email {
    word-break: break-word;
  }

  .description {
    font-weight: bold;
    font-style: italic;
    font-size: 14px;
    opacity: .3;
  }

  .number {
    opacity: .5;
  }

  .status {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    margin: auto;

    &.gray {
      background: $gray;
    }

    &.blue {
      background: $blue;
    }

    &.green {
      background: $green;
    }

    &.yellow {
      background: $yellow;
    }
  }
</style>
